import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "aws-order" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "search-warp" }
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = {
  key: 0,
  class: "tips"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "popover-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "popover-item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "popover-item" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "table" }
const _hoisted_19 = { class: "popover-item" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "table" }
const _hoisted_24 = {
  key: 0,
  class: "popover-item"
}
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  key: 1,
  class: "popover-item"
}
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = {
  key: 2,
  class: "popover-item"
}
const _hoisted_31 = { class: "label" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 2,
  class: "status-text"
}
const _hoisted_34 = {
  key: 0,
  class: "tips"
}
const _hoisted_35 = { class: "popover-item" }
const _hoisted_36 = { class: "label" }
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "popover-item" }
const _hoisted_39 = { class: "label" }
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "popover-item" }
const _hoisted_42 = { class: "label" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = {
  key: 1,
  class: "tips"
}
const _hoisted_45 = { class: "popover-item" }
const _hoisted_46 = { class: "label" }
const _hoisted_47 = { class: "value" }
const _hoisted_48 = {
  key: 2,
  class: "tips"
}
const _hoisted_49 = {
  key: 0,
  class: "popover-item"
}
const _hoisted_50 = { class: "label" }
const _hoisted_51 = { class: "value" }
const _hoisted_52 = {
  key: 1,
  class: "popover-item"
}
const _hoisted_53 = { class: "label" }
const _hoisted_54 = { class: "value" }
const _hoisted_55 = {
  key: 2,
  class: "popover-item"
}
const _hoisted_56 = { class: "label" }
const _hoisted_57 = { class: "value" }

import { ref, reactive, computed, onUnmounted } from 'vue';
import { Table, Select, DatePicker, Tooltip, Button, Popover } from 'ant-design-vue';
import { useRouter } from 'vue-router';
import { useVueI18n } from '@/hooks';
import PageTitle from '@/layout/title.vue';
import MainWarp from '@/layout/mainWarp.vue';
import dayjs, { Dayjs } from 'dayjs';
import { exportData, downFile, hasCode, getOrgId, addSymbol } from '@/utils/tool';
import { tablePage } from '@/layout';
import { getAmazonOrder } from '@/api/aws/index';
import { OrderListQuery, OrderListItem, OrderListBind } from '@/api/aws/type';
import { ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons-vue';
import { setUserTime } from '@/utils/timeTool';
import AmazonBindModal from './_components/amazon-bind-modal.vue';
import useData from './data';
import NotificationPopover from './_components/notificationPopover.vue';

type AwsListItem = OrderListItem & { countdown?: string };

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useVueI18n();
const router = useRouter();

const { columns, businessList, orderStatusList } = useData();

const getBusinessName = (business: string) => {
  return business === 'NEWSMS' ? 'SMS' : business;
};

const queryData = reactive({
  business: '',
  orderStatus: '',
  date: [
    dayjs(new Date()).subtract(12, 'month').startOf('days'),
    dayjs(new Date()).endOf('days'),
  ] as [Dayjs, Dayjs],
  loading: false,
  dataList: [],
  orderType: '',
});
const amazonBindModalVisible = ref(false);
const intervalId = ref(null as unknown as NodeJS.Timeout);
const orderList = ref([] as AwsListItem[]);
const countdownExpireTime = (record: AwsListItem, type?: 1) => {
  const currentTime = new Date().getTime();
  const diff = Math.floor((record.toBindTime - currentTime) / 1000);
  if (diff < 0) {
    record.orderStatus = 'unbind';
    record.countdown = '00:00:00';
    if (orderList.value.every(item => item.orderStatus !== 'pending')) {
      clearInterval(intervalId.value);
    }
    return type;
  }
  const hours = Math.floor(diff / 3600);
  const minutes = Math.floor((diff % 3600) / 60);
  const seconds = diff % 60;
  const countdown = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
    seconds,
  ).padStart(2, '0')}`;
  record.countdown = countdown;
};
const disableDate = (currentDate: Dayjs) => {
  return currentDate.valueOf() > new Date().getTime();
};
const pages = tablePage(() => GetAmazonOrder());
const handleChange = () => {
  pages.pagination.current = 1;
  GetAmazonOrder();
};
const jump = (name: string, record?: AwsListItem) => {
  if (name === 'profile') {
    router.push({
      name: 'profile',
    });
  }
  if (name === 'order') {
    sessionStorage.setItem('awsOrderId', record!.id);
    router.push({
      name: 'orderManagement',
    });
  }
};
const GetAmazonOrder = () => {
  queryData.loading = true;
  getAmazonOrder(
    pages.params({
      business: queryData.business,
      orderStatus: queryData.orderStatus,
      startMonth: dayjs(queryData.date[0]).format('YYYY-MM'),
      endMonth: dayjs(queryData.date[1]).format('YYYY-MM'),
    }),
  )
    .then(res => {
      queryData.loading = false;
      if (res.code === 0) {
        orderList.value = res.data.list as AwsListItem[];
        if (
          orderList.value.some(
            item => item.orderStatus === 'pending' && countdownExpireTime(item, 1) !== 1,
          )
        ) {
          intervalId.value = setInterval(() => {
            orderList.value.forEach(item => {
              if (item.orderStatus === 'pending') {
                countdownExpireTime(item);
              }
            });
          }, 1000);
        }
      }
    })
    .catch(() => {
      queryData.loading = false;
    });
};

const currentData = ref({} as OrderListItem);
const handleBind = (record: OrderListItem) => {
  amazonBindModalVisible.value = true;
  currentData.value = record;
};
const emailTips = (record: any) => {
  const arr = [t('aws.email'), t('aws.email.flow'), t('aws.email.ip')];
  const arr1 = [
    record.emailOrderDetail.emailPackageNum,
    record.emailOrderDetail.flowPackageNum,
    record.emailOrderDetail.ipPackageNum,
  ];
  const ret = [] as string[];
  arr1.forEach((item, index) => {
    if (item) {
      ret.push(arr[index]);
    }
  });
  return ret.join('/');
};

const unbindTips = (record: any) => {
  // 'aws.bindTips.unbind.status.refunded': '退款',
  // 'aws.bindTips.unbind.status.expired': '到期',
  // 'aws.bindTips.unbind.status.upgraded': '升级',
};
GetAmazonOrder();

onUnmounted(() => {
  clearInterval(intervalId.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (jump('profile')))
      }, _toDisplayString(_unref(t)('app.profile.account')) + " >", 1),
      _createElementVNode("span", null, _toDisplayString(_unref(t)('aws.title')), 1)
    ]),
    _createVNode(PageTitle, null, {
      title: _withCtx(() => [
        _createElementVNode("i", {
          class: "iconfont ec-jiantouyou title-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (jump('profile')))
        }),
        _createTextVNode(" " + _toDisplayString(_unref(t)('aws.title')), 1)
      ]),
      _: 1
    }),
    _createVNode(MainWarp, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Select), {
            value: queryData.business,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryData.business) = $event)),
            size: "large",
            class: "select-set",
            options: _unref(businessList),
            onChange: handleChange
          }, null, 8, ["value", "options"]),
          _createVNode(_unref(Select), {
            value: queryData.orderStatus,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryData.orderStatus) = $event)),
            class: "select-set",
            size: "large",
            options: _unref(orderStatusList),
            onChange: handleChange
          }, null, 8, ["value", "options"]),
          _createVNode(_unref(DatePicker).RangePicker, {
            value: queryData.date,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryData.date) = $event)),
            "allow-clear": false,
            format: 'YYYY/MM',
            size: "large",
            picker: "month",
            "disabled-date": disableDate,
            onChange: handleChange
          }, null, 8, ["value"])
        ]),
        _createVNode(_unref(Table), {
          loading: queryData.loading,
          columns: (_unref(columns) as any),
          "row-key": _unref(pages).rowKey,
          "data-source": orderList.value,
          pagination: _unref(pages).pagination,
          scroll: { x: 1300 },
          onChange: _unref(pages).pageChange
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.dataIndex === 'business')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", null, _toDisplayString(getBusinessName(text)), 1),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(record.id), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'orderStatus')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-text", text])
                  }, _toDisplayString(_unref(t)(`aws.${text}`)), 3),
                  (text === 'pending')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)('aws.activeText', {
                  time: record.countdown,
                })), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'notificationStatus')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (text === 'refunded')
                    ? (_openBlock(), _createBlock(NotificationPopover, {
                        key: 0,
                        text: text
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('aws.aswStatus.refunded.tips')), 1)
                        ]),
                        _: 1
                      }, 8, ["text"]))
                    : (text === 'upgraded')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (['AppPush', 'WebPush'].includes(record.business))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                _createVNode(NotificationPopover, { text: text }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('aws.aswStatus.upgraded.tips')), 1),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('aws.apppush.dataCenter')), 1),
                                        _createElementVNode("div", _hoisted_10, _toDisplayString(record.upgradedPushOrderDetail?.dcName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('aws.apppush.dau')), 1),
                                        _createElementVNode("div", _hoisted_13, _toDisplayString((record.upgradedPushOrderDetail?.dau || 0) * 10) + "K ", 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('aws.apppush.vip')), 1),
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('aws.month', {
                            number: record.upgradedPushOrderDetail?.month,
                          })), 1)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["text"])
                              ]))
                            : (['SMS', 'WhatsApp', 'OTP', 'NEWSMS'].includes(record.business))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                  _createVNode(NotificationPopover, { text: text }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_unref(t)('aws.aswStatus.upgraded.tips')), 1),
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('aws.whatsapp.recharge')), 1),
                                          _createElementVNode("div", _hoisted_21, "$" + _toDisplayString(record.upgradedChargeMoney), 1)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["text"])
                                ]))
                              : (['Email'].includes(record.business))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                    _createVNode(NotificationPopover, { text: text }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('aws.aswStatus.upgraded.tips')), 1),
                                        _createElementVNode("div", _hoisted_23, [
                                          (record.upgradedEmailOrderDetail?.emailPackageNum)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('aws.email')), 1),
                                                _createElementVNode("div", _hoisted_26, _toDisplayString(record.upgradedEmailOrderDetail?.emailPackageNum), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (record.upgradedEmailOrderDetail?.flowPackageNum)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('aws.email.flow')), 1),
                                                _createElementVNode("div", _hoisted_29, _toDisplayString(record.upgradedEmailOrderDetail?.flowPackageNum), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (record.upgradedEmailOrderDetail?.ipPackageNum)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('aws.email.ip')), 1),
                                                _createElementVNode("div", _hoisted_32, _toDisplayString(record.upgradedEmailOrderDetail?.ipPackageNum), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["text"])
                                  ]))
                                : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_unref(t)(`aws.aswStatus.${text}`)), 1))
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'orderInfo')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("p", null, _toDisplayString(_unref(addSymbol)(record.chargeMoney)), 1),
                  (['AppPush', 'WebPush'].includes(record.business))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                        _createVNode(_unref(Popover), { "overlay-class-name": "aws-order-popover" }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)('aws.apppush.dataCenter')), 1),
                              _createElementVNode("div", _hoisted_37, _toDisplayString(record.pushOrderDetail.dcName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)('aws.apppush.dau')), 1),
                              _createElementVNode("div", _hoisted_40, _toDisplayString(record.pushOrderDetail.dau * 10) + "K", 1)
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('aws.apppush.vip')), 1),
                              _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('aws.month', {
                          number: record.pushOrderDetail.month,
                        })), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString((record.pushOrderDetail.dau || 0) * 10) + "k " + _toDisplayString(_unref(t)('aws.apppush.dau')) + " ", 1),
                            _createVNode(_unref(InfoCircleFilled))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : (['SMS', 'WhatsApp', 'OTP', 'NEWSMS'].includes(record.business))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                          _createVNode(_unref(Popover), { "overlay-class-name": "aws-order-popover" }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('aws.whatsapp.recharge')), 1),
                                _createElementVNode("div", _hoisted_47, "$" + _toDisplayString(record.chargeMoney), 1)
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(t)('aws.whatsapp.recharge')) + " ", 1),
                              _createVNode(_unref(ExclamationCircleFilled))
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (['Email'].includes(record.business))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                            _createVNode(_unref(Popover), { "overlay-class-name": "aws-order-popover" }, {
                              content: _withCtx(() => [
                                (record.emailOrderDetail.emailPackageNum)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(t)('aws.email')), 1),
                                      _createElementVNode("div", _hoisted_51, _toDisplayString(record.emailOrderDetail.emailPackageNum), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (record.emailOrderDetail.flowPackageNum)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                      _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(t)('aws.email.flow')), 1),
                                      _createElementVNode("div", _hoisted_54, _toDisplayString(record.emailOrderDetail.flowPackageNum), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (record.emailOrderDetail.ipPackageNum)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(t)('aws.email.ip')), 1),
                                      _createElementVNode("div", _hoisted_57, _toDisplayString(record.emailOrderDetail.ipPackageNum), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(emailTips(record)) + " ", 1),
                                _createVNode(_unref(ExclamationCircleFilled))
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'expireTime')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createTextVNode(_toDisplayString(_unref(setUserTime)(record.expireTime)), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'createTime')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createTextVNode(_toDisplayString(_unref(setUserTime)(record.createTime)), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'operate')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                  (record.orderStatus === 'bound')
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        type: "link",
                        class: "button-link",
                        onClick: ($event: any) => (jump('order', record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('aws.engageLabOrder')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (
                  ((record.notificationStatus === 'refunded' ||
                    record.notificationStatus === 'expired' ||
                    record.notificationStatus === 'upgraded') &&
                    record.orderStatus === 'unbind') ||
                  record.orderStatus === 'cancelled' ||
                  record.orderStatus === 'pending'
                )
                          ? (_openBlock(), _createBlock(_unref(Tooltip), { key: 0 }, _createSlots({
                              default: _withCtx(() => [
                                _createVNode(_unref(Button), {
                                  type: "link",
                                  class: "button-link",
                                  disabled: true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('aws.bind')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, [
                              (record.orderStatus === 'pending')
                                ? {
                                    name: "title",
                                    fn: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('aws.bindTips')), 1)
                                    ]),
                                    key: "0"
                                  }
                                : (record.orderStatus === 'cancelled')
                                  ? {
                                      name: "title",
                                      fn: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('aws.bindTips.cancelled')), 1)
                                      ]),
                                      key: "1"
                                    }
                                  : (
                    record.orderStatus === 'unbind' &&
                    (record.notificationStatus === 'refunded' ||
                      record.notificationStatus === 'expired' ||
                      record.notificationStatus === 'upgraded')
                  )
                                    ? {
                                        name: "title",
                                        fn: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('aws.bindTips.unbind', {
                      status: `\{${_unref(t)('aws.bindTips.unbind.status.' + record.notificationStatus)}\}`,
                    })), 1)
                                        ]),
                                        key: "2"
                                      }
                                    : undefined
                            ]), 1024))
                          : (_openBlock(), _createBlock(_unref(Button), {
                              key: 1,
                              type: "link",
                              class: "button-link",
                              onClick: ($event: any) => (handleBind(record))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('aws.bind')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                      ], 64))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "row-key", "data-source", "pagination", "onChange"])
      ]),
      _: 1
    }),
    (amazonBindModalVisible.value)
      ? (_openBlock(), _createBlock(AmazonBindModal, {
          key: 0,
          open: amazonBindModalVisible.value,
          "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((amazonBindModalVisible).value = $event)),
          data: currentData.value,
          onBindSuccess: GetAmazonOrder
        }, null, 8, ["open", "data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})